<template>
  <div class="company">
    <div class="presentation-company">
      <div class="column items-center q-py-xl">
        <div class="presentation-company__img-logo">
          <img alt="Logo" src="@/assets/img/logo_impetus.png" />
        </div>

        <div class="presentation-company__img-logomarca">
          <img alt="Logo" src="@/assets/img/logomarca_appembarque_white.png" />
        </div>
      </div>
    </div>

    <div>
      <form @submit.prevent="getCompanyHost" class="presentation-company__form">
        <h1 class="presentation-company__title">
          ENTRE COM O CNPJ DA EMPRESA
        </h1>
        <q-input
          type="text"
          v-model="cnpj"
          name="cnpj"
          label="CNPJ"
          color="teal-8"
          input-class="text-uppercase"
          mask="##.###.###/####-##"
          filled
          lazy-rules
          :rules="[
            (val) => !!val || 'Por favor informe o CNPJ',
            (val) => !!val.match(/^\d{2}[.]\d{3}[.]\d{3}[\/]\d{4}[-]\d{2}$/) || 'CNPJ inválido' 
          ]"
        >
          <template v-slot:prepend>
            <q-icon name="person_outline" />
          </template>
        </q-input>

        <q-input
          type="text"
          v-model="key"
          name="key"
          label="Chave de autenticação"
          color="teal-8"
          input-class="text-uppercase"
          mask="XXXX-XXXX"
          filled
          lazy-rules
          :rules="[
            (val) => !!val || 'Por favor informe a chave',
          ]"
        >
          <template v-slot:prepend>
            <q-icon name="key" />
          </template>
        </q-input>

        <div class="row justify-center">
          <q-btn
            unelevated
            no-caps
            label="Confirmar identificação"
            type="submit"
            class="presentation-company__button"
          />
        </div>
      </form>
    </div>


    <div class="link_eulabs">
      <span>DESENVOLVIDO POR</span><br />
      <a href="https://eulabs.com.br/" target="_blank"
        >EULABS - SOLUÇÕES EM TECNOLOGIA</a
      >
    </div>

    <div class="text_version">
      <span>V. {{ version }}</span>
    </div>

    <q-dialog
      v-model="dialogConnectionOff"
      persistent
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="text-black" style="width: 300px">
        <q-card-section>
          <div class="text-h6 row items-center">
            Problemas com a internet
            <i class="ri-signal-wifi-error-line q-pl-sm"></i>
          </div>
        </q-card-section>

        <q-card-section class="q-pt-none row items-center">
          <div class="column q-pl-sm">
            <span>Verifique se você está conectado a internet</span>
          </div>
        </q-card-section>

        <q-card-actions align="right" class="bg-white">
          <q-btn
            @click="checkVersionAndConnection()"
            unelevated
            no-caps
            label="Verificar agora"
            class="q-py-xs q-px-sm text-weight-bold"
            text-color="white"
            color="teal-8"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { 
  API_EULABS,
  HOST_COMPANY, 
  HASH_COMPANY,
  CHECK_DATE_AUTHENTICATION
} from "../variables";

import axios from 'axios';
import { mutations } from "../store";
import { Loading, openURL } from "quasar";
import { setLocalStorage, getLocalStorage } from '../functions';

export default {
  mounted() {
    this.checkValidateLicense();
  },

  data() {
    return {
      cnpj: "",
      key: '',
      version: "3.0.0",
      dialogConnectionOff: false,
    };
  },

  methods: {
    openURL,
    getCompanyHost() {
      if(!this.cnpj || !this.cnpj.match(/^\d{2}[.]\d{3}[.]\d{3}[\/]\d{4}[-]\d{2}$/)) {
        mutations.openAlert({
          open: true,
          message: "Por favor, informe um CNPJ válido!",
          status: 400,
        });
        return;
      }

      if(!this.key || this.key.length < 9) {
        mutations.openAlert({
          open: true,
          message: "Por favor, informe uma chave válida!",
          status: 400,
        });
        return;
      }

      const header = {
        'X-MODULE': 'EmbarqueRapido',
        'CNPJ': this.cnpj,
        'PARAMETER_NAME': 'host',
        'MERCHANT_KEY': this.key.toUpperCase(),
      }

      axios
        .get(API_EULABS+'/license', { headers: header })
        .then((response) => {
          const moduleApp = response.data.modules.find((module) => module.name === 'EmbarqueRapido')
          if (moduleApp) {
            const host = moduleApp.parameters.find((item) => item.name === 'host').value
            const dateNow = new Date().toLocaleDateString().split('/')
            setLocalStorage(CHECK_DATE_AUTHENTICATION, `${dateNow[1]}/${dateNow[0]}/${dateNow[2]}`)
            setLocalStorage(HOST_COMPANY, host)
            setLocalStorage(HASH_COMPANY, response.data.hash)
            this.$router.push("/login");
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response.data.return.status === 'desautorizado') {
            mutations.openAlert({
              open: true,
              message: "Empresa informada não tem permissão de acesso!",
              status: 500,
            });
          } else if (error.response.data.return.status) {
            mutations.openAlert({
              open: true,
              message: error.response.data.return.status,
              status: 500,
            });
          } else {
            mutations.openAlert({
              open: true,
              message: "Ops! Tivemos um problema com a sua conexão!",
              status: 500,
            });
          }
        });
    },
    checkValidateLicense() {
      if (getLocalStorage(HASH_COMPANY)) {
        Loading.show();
        const header = {
          'PARAMETER_NAME': 'host',
          'HASH': getLocalStorage(HASH_COMPANY)
        }

        axios
          .get(API_EULABS+'/license', { headers: header })
          .then((response) => {
            const moduleApp = response.data.modules.find((module) => module.name === 'EmbarqueRapido')
            if (moduleApp) {
              const host = moduleApp.parameters.find((item) => item.name === 'host').value
              const dateNow = new Date().toLocaleDateString().split('/')
              setLocalStorage(CHECK_DATE_AUTHENTICATION, `${dateNow[1]}/${dateNow[0]}/${dateNow[2]}`)
              setLocalStorage(HOST_COMPANY, host)
              setLocalStorage(HASH_COMPANY, response.data.hash)
              this.$router.push("/login");
            }
          })
          .catch((error) => {
            console.log(error)
            if (error.response.data.return.status === 'desautorizado') {
              mutations.openAlert({
                open: true,
                message: "A sua licença expirou e está sem permissão de acesso!",
                status: 500,
              });
              window.localStorage.clear();
              window.sessionStorage.clear();
            } else if (error.response.data.return.status) {
              mutations.openAlert({
                open: true,
                message: error.response.data.return.status,
                status: 500,
              });
            } else {
              mutations.openAlert({
                open: true,
                message: "Ops! Tivemos um problema com o servidor. Tente novamente ou entre em contato com o nosso suporte!",
                status: 500,
              });
            }
          }).finally(() => Loading.hide());
      }
    }
  },
};
</script>

<style lang="scss">
@import '../scss/variables';

.company {
  height: 100vh;
}

.presentation-company {
  background-color: $color-green-dark;
}

.presentation-company__img-logo {
  img {
    width: 160px;
  }
}

.presentation-company__img-logomarca {
  margin-top: 60px;
  margin-bottom: 50px;

  img {
    width: 247px;
  }
}

.presentation-company__title {
  color: $color-green-text;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  line-height: normal;
  margin: 0;
  margin-bottom: 10px;
}

.presentation-company__form {
  display: grid;
  align-content: end;
  gap: 10px;
  padding: 35px 30px 0 30px;
}

.presentation-company__button {
  background: $color-green-dark;
  color: white;
  font-weight: bold;
  width: 100%;
  padding: 14px;
}

.link_eulabs {
  margin-top: 40px;
  width: 100%;
  text-align: center;
  font-size: 13px;
  color: #808285;
  
  a {
    font-weight: bold;
    color: $color-green-brand;
    text-decoration: none;
  }
}

.text_version {
  margin-top: 10px;
  padding-bottom: 20px;
  width: 100%;
  text-align: center;
  font-size: 13px;
  font-weight: bold;
  color: $color-green-light;
}
</style>